import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { getApiErrorMessage } from '../../shared/utils/error-utils';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { LocalStorageKeys } from '../constants/local-storage.constants';
import { JwtService } from '../services/jwt.service';
import { Paths } from '../constants/path.constants';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  const localStorageService = inject(LocalStorageService);
  const jwtService = inject(JwtService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const message = getApiErrorMessage(error);
      toastr.error(message);
      if (error.status === 401) {
        localStorageService.removeItem(LocalStorageKeys.USER_DETAILS);
        localStorageService.removeItem(LocalStorageKeys.ACCESS_TOKEN);
        jwtService.updateToken(null);
        router.navigate([Paths.AUTH]);
      }
      return throwError(() => error);
    })
  );
};
